export default __webpack_public_path__ + "static/media/badge.7d28cddc.png";